<template>
	<button :class="[sizeClasses, colourClasses, customClasses]" class="btn" @click="$emit('click')"><slot>Button</slot></button>
</template>
<script>
export default {
	props: {
		size: {
			type: String,
			required: false,
			default: null
		},
		colour: {
			type: String,
			required: false,
			default: null
		},
		customClasses: {
			type: String,
			required: false,
			default: null
		}
	},
	data: function () {
		return {
		}
	},
	computed: {
		sizeClasses() {
			switch (this.size) {
				case 'small':
					return 'btn-sm'
				case 'large':
					return 'btn-lg'
			}
			return '';
		},
		colourClasses() {
			switch (this.colour) {
				case 'primary':
					return 'btn-primary'
				case 'danger':
					return 'btn-danger'
			}
			return ''
		}
	},
}
</script>